import React, {useState} from "react";
import FormRegisterForGame, {
	defaultRegisterForGameState,
} from "pages/Registration/FormRegisterForGame";
import {useSelector, useDispatch} from "react-redux";
import {isNeedToRegisterForYear} from "modules/selectors";
import {Redirect} from "react-router";
import {RegistrationValidate} from "modules/utils/FormValidations";
import {each} from "lodash";
import {userReturningRegisterForGameAction} from "modules/actions/user";

export const ReturningUser: React.FC = () => {
	const dispatch = useDispatch();
	const is_need_register_for_game = useSelector(isNeedToRegisterForYear);
	const [formState, setFormState] = useState(defaultRegisterForGameState);

	const validateFormItem = (name: string, value: string) => {
		if (name === "terms" || name === "team_name") {
			return RegistrationValidate[name](value);
		}
		return null;
	};

	const validateForm = (): typeof defaultRegisterForGameState.form_errors => {
		const {form_element} = formState;

		let errors: typeof defaultRegisterForGameState.form_errors = {
			team_name: "",
			terms: "",
		};
		each(form_element, (value, name) => {
			errors = {
				...errors,
				[name]: validateFormItem(name, value),
			};
		});

		return errors;
	};

	const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();

		const form_errors = validateForm();
		if (
			!form_errors.terms?.length &&
			formState.form_element.terms === "1"
		) {
			dispatch(
				userReturningRegisterForGameAction(formState.form_element)
			);
		}

		setFormState({
			...formState,
			form_errors,
		});
	};

	const handleChange = (event: React.FormEvent<HTMLFormElement>) => {
		const {name, checked, type, value} = event.target as HTMLFormElement;
		const {form_element} = formState;

		if (type === "checkbox") {
			validateFormItem(name, checked ? "1" : "");

			setFormState({
				...formState,
				form_element: {
					...form_element,
					[name]: checked ? "1" : "0",
				},
			});
		} else {
			validateFormItem(name, value);
			setFormState({
				...formState,
				form_element: {
					...form_element,
					[name]: value,
				},
			});
		}
	};

	if (!is_need_register_for_game) {
		return <Redirect to="/pick-em" />;
	}
	return (
		<FormRegisterForGame
			isReturningUser={true}
			handleSubmit={handleSubmit}
			handleChange={handleChange}
			form_errors={formState.form_errors}
			form_element={formState.form_element}
		/>
	);
};
export default ReturningUser;
